import AllChatsPage from './all-chats.page';
export default AllChatsPage;
